import { StatCard } from "@design-system/StatCard/StatCard";

import { useClientTotalUsersStatQuery } from "./ClientTotalUsersStat.g";

type Props = {
  clientId: string;
};

export const ClientTotalUsersStat = ({ clientId }: Props) => {
  const { data } = useClientTotalUsersStatQuery({
    clientId,
  });

  return (
    <StatCard
      icon="faUser"
      title="Users"
      value={data?.client?.employees?.totalCount?.toString() ?? "0"}
    />
  );
};
